import { render } from "./CustomerSuccess.vue?vue&type=template&id=6e8c431b&scoped=true"
import script from "./CustomerSuccess.vue?vue&type=script&lang=js"
export * from "./CustomerSuccess.vue?vue&type=script&lang=js"

import "./CustomerSuccess.vue?vue&type=style&index=0&id=6e8c431b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8c431b"]])

export default __exports__